<template>
  <loading :active="isFullPageLoading" :is-full-page="true" :height="100" :width="100"></loading>
  <div :class="componentClassName">
    <a-page-heading :id="idName">発着信履歴 </a-page-heading>
    <a-select-field
      v-if="companyID === POINT && companyIDList.length !== 0"
      id="-companyId"
      v-model="selectedCompanyID"
      :options="companyIDList"
      :searchable="true"
    />
    <m-section variant="fullpage">
      <m-action-card class="t-history-list__card" :no-header-margin="true">
        <div class="t-history-list__controls">
          <form class="t-history-list__search-form" @submit.prevent="handleSubmitSearchForm">
            <div class="t-history-list__search">
              <a-select-field id="searchTypeOptions" v-model="searchForm.type" :options="searchTypeOptions" />
              <span class="t-history-list__search-separator" />
              <a-text-field
                id="search_field"
                v-model="searchForm.term"
                type="search"
                placeholder="検索"
                :maxlength="selMaxLength"
              />
            </div>
            <div class="t-history-list__search-period">
              <m-calendar-range-field
                v-model="searchForm.periods"
                :min-date="minDate"
                :max-date="maxDate"
                start-date-placeholder="開始期間"
                end-date-placeholder="終了期間"
                :start-date-nav-tooltip-previous="true"
                start-date-nav-tooltip-previous-message="3ヶ月前のデータまで参照できます"
                :start-date-nav-tooltip-next="true"
                start-date-nav-tooltip-next-message="終了期間より未来の日付は選択できません"
                :end-date-nav-tooltip-previous="true"
                end-date-nav-tooltip-previous-message="開始期間より過去の日付は選択できません"
                :end-date-nav-tooltip-next="true"
                end-date-nav-tooltip-next-message="未来の日付は選択できません"
              />
            </div>
            <div class="t-history-list__search-button">
              <a-button
                id="search_button"
                variant="fill"
                color="primary"
                size="small"
                label="検索"
                icon="search"
                icon-color="white"
                @click="handleSearchClick"
              />
            </div>
            <div v-if="companyID !== POINT && authInfo !== 'operator'" class="t-history-list__search-button">
              <a-button
                id="download"
                variant="fill"
                color="primary"
                size="small"
                label="CSVダウンロード"
                icon="download"
                icon-color="white"
                @click="handleDownloadClick"
              />
            </div>
          </form>
        </div>
        <div class="t-history-list__data-table">
          <m-data-table
            ref="dataTable"
            :empty-text="emptyText"
            :fit="true"
            :data="dataList"
            :is-loading="isLoading"
            :is-history-list-table="true"
            @rowClick="handleRowClick($event.row)"
          >
            <!--<a-data-table-column ref="tagColumn" prop="tag" label="タグ" align="left" :filterable="true" :width="110">
              <template #default="scope">
                <a-tag v-if="scope.row.tag" :outline="true">{{ scope.row.tag }}</a-tag>
              </template>
              <template #filter="scope">
                <m-filter-dialog
                  v-if="scope"
                  variant="filter"
                  :data-list="tagFilterDataList"
                  :handle-filter-cancel="() => handleFilterCancel('tag')"
                  :handle-filter-confirm="data => handleFilterConfirm('tag', data)"
                />
              </template>
            </a-data-table-column>-->
            <a-data-table-column prop="status" label="ステータス" align="left" :filterable="true" :width="140">
              <template #default="scope">
                <div class="t-history-list__data-cell-status">
                  <a-icon
                    :icon="getCallStatusIcon(scope.row.status, scope.row.voicemessageFlag, scope.row.overFlowFlag)"
                    :color="
                      scope.row.status === '不在着信' ||
                      scope.row.status === '留守電' ||
                      scope.row.withheldNumberFlag ||
                      scope.row.overseasNumberFlag
                        ? 'red'
                        : 'black'
                    "
                  />
                  {{ scope.row.status }}
                </div>
              </template>
              <template #filter="scope">
                <m-filter-dialog
                  v-if="scope"
                  variant="filter"
                  :data-list="statusFilterDataList"
                  :selected-items="checkedStatus"
                  :handle-filter-cancel="() => handleFilterCancel('status')"
                  :handle-filter-confirm="data => handleFilterConfirm('status', data, 0)"
                />
              </template>
            </a-data-table-column>
            <a-data-table-column prop="overFlowFlag" label="あふれ呼" align="center" :filterable="true" :width="85">
              <template #default="scope">
                <span>{{ scope.row.overFlowFlag ? '○' : '' }}</span>
              </template>
              <template #filter="scope">
                <m-filter-dialog
                  v-if="scope"
                  variant="filter"
                  :data-list="overFlowFilterDataList"
                  :selected-items="checkedOverFlow"
                  :handle-filter-cancel="() => handleFilterCancel('overFlowFlag')"
                  :handle-filter-confirm="data => handleFilterConfirm('overFlowFlag', data, 0)"
                />
              </template>
            </a-data-table-column>
            <a-data-table-column
              prop="specificNumberFlag"
              label="特定番号対応"
              align="center"
              :filterable="true"
              :width="85"
            >
              <template #default="scope">
                <span>{{ scope.row.specificNumberFlag ? '○' : '' }}</span>
              </template>
              <template #filter="scope">
                <m-filter-dialog
                  v-if="scope"
                  variant="filter"
                  :data-list="overFlowFilterDataList"
                  :selected-items="checkedOverFlow"
                  :handle-filter-cancel="() => handleFilterCancel('specificNumberFlag')"
                  :handle-filter-confirm="data => handleFilterConfirm('specificNumberFlag', data, 0)"
                />
              </template>
            </a-data-table-column>
            <a-data-table-column prop="phonebook_name" label="相手先番号" align="left" :width="130" />
            <a-data-table-column prop="phone_number" label="自番号" align="left" :filterable="true" :width="130">
              <template #default="scope">
                <span>{{ scope.row.status === '内線' ? '' : scope.row.phone_number }}</span>
              </template>
              <template #filter="scope">
                <m-filter-dialog
                  v-if="scope"
                  variant="filter"
                  :searchable="true"
                  :data-list="phoneNumberFilterDataList"
                  :selected-items="checkedPhoneNumber"
                  :handle-filter-cancel="() => handleFilterCancel('phone_number')"
                  :handle-filter-confirm="data => handleFilterConfirm('phone_number', data, 0)"
                />
              </template>
            </a-data-table-column>
            <a-data-table-column prop="pbSettingName" label="プッシュ番号名" align="left" :width="130" />
            <a-data-table-column prop="agent_name" label="応対者" align="left" :filterable="true" :width="100">
              <template #filter="scope">
                <m-filter-dialog
                  v-if="scope"
                  variant="filter"
                  :searchable="true"
                  :data-list="agentFilterDataList"
                  :selected-items="checkedAgent"
                  :handle-filter-cancel="() => handleFilterCancel('agent_name')"
                  :handle-filter-confirm="data => handleFilterConfirm('agent_name', data, 0)"
                />
              </template>
            </a-data-table-column>
            <a-data-table-column prop="start_dt" label="開始日時" align="left" :filterable="true" :width="135">
              <template #filter="scope">
                <m-filter-dialog
                  v-if="scope"
                  variant="sort-time"
                  :handle-sort-ascending="() => handleSort('start_dt', 'asc')"
                  :handle-sort-descending="() => handleSort('start_dt', 'desc')"
                />
              </template>
            </a-data-table-column>
            <a-data-table-column prop="dispTime" label="通話時間" align="left" :filterable="true" :width="85">
              <template #filter="scope">
                <m-filter-dialog
                  v-if="scope"
                  variant="sort-call"
                  :handle-sort-ascending="() => handleSort('seconds', 'asc')"
                  :handle-sort-descending="() => handleSort('seconds', 'desc')"
                />
              </template>
            </a-data-table-column>
            <a-data-table-column prop="memo" label="メモ" align="left">
              <template #default="scope">
                <div class="t-history-list__data-cell-memo">
                  <div class="t-history-list__data-cell-memo-text">
                    {{ scope.row.memo }}
                  </div>
                  <div class="t-history-list__data-cell-memo-setting">
                    <p
                      class="t-history-list__buttons"
                      @mouseover="doRecordingHighLight(scope.index)"
                      @mouseleave="doNotRecordingHighLight(scope.index)"
                    >
                      <a-button
                        v-if="scope.row.recordingUrl && scope.row.voiceToTextStatus !== 'absent'"
                        :id="'play-recording-' + scope.index"
                        :data-tooltip="'通話録音再生'"
                        :inline="true"
                        variant="round"
                        color="white"
                        size="large"
                        icon="recording-play"
                        :icon-color="isRecordingHover[scope.index] ? 'orange' : 'black'"
                        :disabled="!canPlayRecordings"
                        @click.stop="handlePlayRecordingClick(scope.row)"
                      />
                      <a-button
                        v-else-if="scope.row.recordingUrl && scope.row.voiceToTextStatus == 'absent'"
                        :id="'play-recording-' + scope.index"
                        :data-tooltip="'通話録音再生'"
                        :inline="true"
                        variant="round"
                        color="white"
                        size="large"
                        icon="recording-play"
                        :icon-color="isRecordingHover[scope.index] ? 'orange' : 'black'"
                        :disabled="!canPlayRecordings"
                        @click.stop="showAbsentError('通話録音の再生')"
                      />
                    </p>
                    <template v-if="scope.row.recordingUrl && scope.row.voiceToTextStatus === 'textExisted'">
                      <p
                        v-if="companyID !== POINT"
                        v-show="voiceToTextOn"
                        class="t-history-list__buttons"
                        @mouseover="doTextHighLight(scope.index)"
                        @mouseleave="doNotTextHighLight(scope.index)"
                      >
                        <a-button
                          :id="'voice-to-text-' + scope.index"
                          :data-tooltip="'テキスト化済み'"
                          variant="round"
                          size="large"
                          icon="text"
                          icon-color="isTextHover[scope.index] ? 'orange' : 'black'"
                          color="white"
                          :inline="true"
                          disabled="false"
                        />
                      </p>
                    </template>
                    <template v-else-if="scope.row.recordingUrl && scope.row.voiceToTextStatus === 'absent'">
                      <p
                        v-if="companyID !== POINT"
                        v-show="voiceToTextOn"
                        class="t-history-list__buttons"
                        @mouseover="doTextHighLight(scope.index)"
                        @mouseleave="doNotTextHighLight(scope.index)"
                      >
                        <a-button
                          :id="'voice-to-text-' + scope.index"
                          :data-tooltip="'テキスト化'"
                          variant="round"
                          size="large"
                          icon="text"
                          icon-color="isTextHover[scope.index] ? 'orange' : 'black'"
                          color="white"
                          :inline="true"
                          @click.stop="showAbsentError('音声テキスト化')"
                        />
                      </p>
                    </template>
                    <template
                      v-else-if="
                        scope.row.recordingUrl &&
                        (scope.row.voiceToTextStatus === 'processing' ||
                          scope.row.voiceToTextStatus === 'cfUploadProcessing')
                      "
                    >
                      <p
                        v-if="companyID !== POINT"
                        v-show="voiceToTextOn"
                        class="t-history-list__buttons"
                        @mouseover="doTextHighLight(scope.index)"
                        @mouseleave="doNotTextHighLight(scope.index)"
                      >
                        <a-button
                          :id="'voice-to-text-' + scope.index"
                          :data-tooltip="'テキスト化中'"
                          variant="round"
                          size="large"
                          icon="text"
                          icon-color="grey"
                          color="white"
                          :inline="true"
                          disabled="false"
                        />
                      </p>
                    </template>
                    <template
                      v-else-if="
                        scope.row.recordingUrl &&
                        (scope.row.voiceToTextStatus === 'textDeleted' ||
                          !scope.row.voiceToTextStatus ||
                          scope.row.voiceToTextStatus === 'textFailed')
                      "
                    >
                      <p
                        v-if="companyID !== POINT"
                        v-show="voiceToTextOn"
                        class="t-history-list__buttons"
                        @mouseover="doTextHighLight(scope.index)"
                        @mouseleave="doNotTextHighLight(scope.index)"
                      >
                        <a-button
                          :id="'voice-to-text-' + scope.index"
                          :data-tooltip="'テキスト化'"
                          variant="round"
                          size="large"
                          icon="text"
                          :icon-color="isTextHover[scope.index] ? 'orange' : 'black'"
                          color="white"
                          :inline="true"
                          @click.stop="confirmDoVoiceToText(scope.row.recordingUrl, scope.row.CallSid)"
                        />
                      </p>
                    </template>
                  </div>
                </div>
              </template>
            </a-data-table-column>
            <a-data-table-column :width="120" align="center" :is-button="true">
              <template #button>
                <div class="a-data-table-header__bulk-download-button t-history-list__buttons">
                  <a-button
                    id="batch-download-recording"
                    :data-tooltip="'通話録音のダウンロード'"
                    variant="icon"
                    color="grey"
                    icon="download"
                    :icon-color="deleteRecordingDisabled ? 'grey' : 'black'"
                    :disabled="deleteRecordingDisabled"
                    @click.stop="handleClickBulkDownloadRecording()"
                  />
                </div>
                <div class="a-data-table-header__bulk-delete-button t-history-list__buttons">
                  <a-button
                    id="delete-recording"
                    :data-tooltip="voiceToTextOn ? '通話録音・テキストの削除' : '通話録音の削除'"
                    variant="icon"
                    color="grey"
                    icon="trash"
                    :icon-color="deleteRecordingDisabled ? 'grey' : 'black'"
                    :disabled="deleteRecordingDisabled"
                    @click.stop="deleteRecording()"
                  />
                </div>
              </template>
              <template #checkbox>
                <a-checkbox
                  v-if="canDeleteRecordings"
                  id="check-all-cbx"
                  v-model="checkAllCbx"
                  label="."
                  :disabled="!canPlayRecordings || loading || Object.keys(recordingCbx).length == 0"
                  @click="doCheckAll()"
                />
              </template>
              <template #default="scope">
                <a-checkbox
                  v-if="scope.row.recordingUrl && canDeleteRecordings"
                  :id="'cbx-' + scope.index"
                  v-model="recordingCbx[scope.row.CallSid]"
                  label="."
                  class="t-history-list__center-cbx"
                  :disabled="!canPlayRecordings"
                  :stop-propagation="true"
                />
              </template>
            </a-data-table-column>
          </m-data-table>
        </div>
        <div v-if="!isLoading" class="t-history-list__pagination">
          <a-pagination :length="pageCount" :current-index="currentPage" @page:selected="handlePageSelect" />
        </div>
      </m-action-card>
    </m-section>
  </div>

  <teleport to="body">
    <o-modal
      id="HistoryList_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <template v-if="modalFlg === 'confirmDoVoiceToText'">
          <a-button
            id="confirmCancelBtn"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCloseModal"
          />
          <a-button
            id="confirmOkBtn"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="doVoiceToText(selectedRecordingUrl, selectedCallSid)"
          />
        </template>
        <template v-if="modalFlg !== 'confirmDoVoiceToText'">
          <a-button
            id="confirmCloseBtn"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="HistoryList_deleteRecordingModal"
      v-model:visible="deleteRecordingModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <!-- <template #title>{{ suspendModalTitle }}</template> -->
      <a-text>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="deleteRecordingModalContent"></span>
      </a-text>
      <template #footer>
        <a-button
          id="deleteRecordingModal-cancelBtn"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelDeleteRecordingModal"
        />
        <a-button
          id="deleteRecordingModalOKBtn"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleOKDeleteRecordingModal"
        />
      </template>
    </o-modal>
  </teleport>
  <!-- Recording player -->
  <teleport to="body">
    <o-modal
      id="HistoryList_playRecordingModal"
      v-model:visible="playRecordingModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
    >
      <template #title><div id="playRecordingModal-text">通話録音</div></template>
      <a-loading v-if="!audioURLs[selectedRow.CallSid]" style="display: flex; justify-content: center"></a-loading>
      <m-audio-player
        v-if="playRecordingModalVisible"
        v-show="audioURLs[selectedRow.CallSid]"
        :audio-url="audioURLs[selectedRow.CallSid]"
        :autoplay="false"
      />
      <template v-if="canDownloadRecordings" #footer>
        <a-button
          v-if="audioURLs[selectedRow.CallSid]"
          id="deleteRecordingModal-downloadBtn"
          variant="outlined"
          color="primary"
          label="ダウンロード"
          size="small"
          @click="handleDownloadRecordingClick"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="HistoryList_bulkDownloadModal"
      v-model:visible="bulkDownloadModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        選択した通話録音をダウンロードをします。ダウンロードする通話の時間や件数によってダウンロードの開始まで時間がかかることがあります。<br />ダウンロードを開始しますか？
      </a-text>
      <a-text>&nbsp;</a-text>
      <a-checkbox
        id="recording-bulk-download-modal-flag-cbx"
        v-model="skipRecordingBulkDownloadModalCbx"
        label="次回からメッセージを表示しない"
      />
      <template #footer>
        <a-button
          id="bulkDownloadCancelBtn"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCloseBulkDownloadModal"
        />
        <a-button
          id="bulkDownloadOkBtn"
          variant="block"
          color="primary"
          label="開始"
          size="small"
          @click="handleBulkDownloadRecording()"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APagination from '@/components/atoms/pagination';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import ASelectField from '@/components/atoms/select-field';
import ATextField from '@/components/atoms/text-field';
import AButton from '@/components/atoms/button';
import MCalendarRangeField from '@/components/molecules/calendar-range-field';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
// import ATag from '@/components/atoms/tag';
import AIcon from '@/components/atoms/icon';
import MFilterDialog from '@/components/molecules/filter-dialog';
import MAudioPlayer from '@/components/molecules/audio-player';
import Loading from 'vue-loading-overlay';

import { debounce, cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';

import { PERMISSIONS_FRONTEND } from '@/libs/constants';

import { utils } from '@/common/utils.js';
import dayjs from 'dayjs';
import { DEFAULT_TIMEZONE } from '@/libs/constants';

import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export default {
  name: 't-history-list',
  components: {
    APagination,
    APageHeading,
    MSection,
    MActionCard,
    ASelectField,
    ATextField,
    AButton,
    MCalendarRangeField,
    MDataTable,
    ADataTableColumn,
    // ATag,
    AIcon,
    MFilterDialog,
    MAudioPlayer,
    Loading,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    //minDate: {
    //  type: Date,
    //  default: null,
    //},
    //maxDate: {
    //  type: Date,
    //  default: null,
    //},
    //dataList: {
    //  type: Array,
    //  default: new Array(0),
    //},
    //page: {
    //  type: Number,
    //  default: 0,
    //},
    //pageCount: {
    //  type: Number,
    //  default: 0,
    //},
    isLoading: {
      type: Boolean,
      default: false,
    },
    tagFilterDataList: {
      type: Array,
      default: new Array(0),
    },
    //statusFilterDataList: {
    //  type: Array,
    //  default: new Array(0),
    //},
    //agentFilterDataList: {
    //  type: Array,
    //  default: new Array(0),
    //},
    handleFilterUpdate: {
      type: Function,
      default: () => {},
    },
    //handleSortUpdate: {
    //  type: Function,
    //  default: () => {},
    //},
    //handleSearchFormSubmit: {
    //  type: Function,
    //  default: () => {},
    //},
    // handleDownloadClick: {
    //   type: Function,
    //   default: () => {},
    // },
    //handleRowClick: {
    //  type: Function,
    //  default: () => {},
    //},
    //handlePageSelect: {
    //  type: Function,
    //  default: () => {},
    //},
    userID: {
      type: String,
      required: true,
    },
    companyID: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchForm: {
        type: 'phonebook_name',
        term: '',
        periods: null,
      },
      searchTypeOptions: [
        {
          value: 'phonebook_name',
          label: '相手先番号',
        },
        {
          value: 'agent_name',
          label: '応対者',
        },
        {
          value: 'memo',
          label: 'メモ',
        },
        {
          value: 'phone_number',
          label: '自番号',
        },
        {
          value: 'text',
          label: 'テキスト',
        },
      ],
      select: '',
      queryList: [],
      dataList: [],
      filterList: [],
      filteringAgentList: [],
      statusFilterDataList: [],
      overFlowFilterDataList: [],
      agentFilterDataList: [],
      phoneNumberFilterDataList: [],
      checkedStatus: [],
      checkedOverFlow: [],
      checkedAgent: [],
      checkedPhoneNumber: [],
      currentPage: 1,
      pageCount: 0,
      parPage: 20,
      emptyText: '',
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      selectedCompanyID: '',
      companyIDList: [],
      filterColumn: 'start_dt',
      filterSort: 'desc',
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      POINT,
      overFlowFlag: '',
      phonebook_name: '',
      agent_name: '',
      memo: '',
      phone_number: '',
      text: '',
      filter: {},
      isInitedFilter: false,
      // #2537
      authInfo: this.$store.state.user.authInfo,
      selMaxLength: '50',
      recordingCbx: {},
      checkAllCbx: false,
      // 通話録音削除モダール
      deleteRecordingModalVisible: false,
      deleteRecordingModalTitle: '',
      deleteRecordingModalContent: '',
      // 通話録音再生モダール
      playRecordingModalVisible: false,
      // 通話録音一括ダウンロードモダール
      bulkDownloadModalVisible: false,
      skipRecordingBulkDownloadModal: false,
      skipRecordingBulkDownloadModalCbx: false,
      selectedRow: {},
      audioURLs: [],
      audioDataList: [],
      loading: false,
      voiceToTextMode: false,
      voiceToTextOn: false,
      modalFlg: '',
      selectedRecordingUrl: '',
      selectedCallSid: '',
      idName: 'h1-historylist',
      recordingUrlList: [],
      minDate: dayjs().tz(DEFAULT_TIMEZONE).format(),
      maxDate: dayjs().tz(DEFAULT_TIMEZONE).format(),
      isTextHover: [],
      isRecordingHover: [],
      trialCompany: false,
      isFullPageLoading: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-history-list', this.isLoading ? 'loading' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
    disableDeleteButton() {
      let flag = false;
      for (const callSid in this.recordingCbx) {
        if (this.recordingCbx[callSid]) flag = true;
      }
      return !flag;
    },
    canVoiceToText() {
      return this.voiceToTextOn && this.companyID !== POINT;
    },
    canDeleteRecordings() {
      return this.companyID !== POINT && (this.authInfo === 'supervisor' || this.authInfo === 'manager');
    },
    canPlayRecordings() {
      if (this.companyID !== POINT) {
        return true;
      }
      if (this.companyID === POINT && this.selectedCompanyID !== POINT && this.authInfo !== 'soOperator') {
        return true;
      }
      return false;
    },
    canDownloadRecordings() {
      if (this.companyID !== POINT && this.authInfo !== 'operator') {
        return true;
      }
      return false;
    },
    deleteRecordingDisabled() {
      return !this.canPlayRecordings || this.disableDeleteButton || !this.canDeleteRecordings;
    },
  },
  watch: {
    searchForm: {
      handler(val) {
        this.search();
      },
      deep: true,
    },
    selectedCompanyID: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (this.companyID === POINT && this.selectedCompanyID !== this.$route.query.companyID) {
          await this.$router.push({ query: { ...this.$route.query, companyID: this.selectedCompanyID } });
        }
        await this.fetchHistoryListHandler();
      }
      if (!newValue) {
        this.selectedCompanyID = oldValue;
      }
    },
    recordingCbx: {
      handler: function () {
        let flag = false;
        for (const callSid in this.recordingCbx) {
          if (!this.recordingCbx[callSid]) {
            this.checkAllCbx = false;
            return;
          } else {
            flag = true;
          }
        }
        this.checkAllCbx = flag;
      },
      deep: true,
    },
  },
  created() {
    // #2423
    if (PERMISSIONS_FRONTEND['HistoryList']) {
      if (!PERMISSIONS_FRONTEND['HistoryList'][this.authInfo]) {
        this.$router.push({ path: '/permission-denied' });
        return;
      }
    }

    if (this.$route.params.filter) {
      this.filter = JSON.parse(String(this.$route.params.filter));
      this.checkedStatus = this.filter['status'];
      this.checkedOverFlow = this.filter['overFlowFlag'];
      this.checkedAgent = this.filter['agent_name'];
    }

    if (this.companyID === POINT) {
      this.fetchCompanyIDListHandler();
    }
    this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
    this.postRequest('/callLogClient/search', { companyID: this.$route.query.companyID })
      .then(e => {
        if (e.status === 'success') {
          this.voiceToTextMode = e.data['voiceToTextFlg'];
          this.voiceToTextOn = e.data['voiceToTextOn'];
        }
      })
      .catch(error => {
        console.log(error);
        this.showErrorModal(messageContent.callLogDownloadError);
      });

    this.postRequest('/callLogClient/getSkipRecordingBulkDownloadModal')
      .then(e => {
        if (e.status === 'success') {
          this.skipRecordingBulkDownloadModal = e.data.value;
        }
      })
      .catch(error => {
        console.log(error);
      });

    // For Trial
    if (utils.chkTrialCompanyID(this.companyID)) {
      this.trialCompany = true;
    }
  },
  mounted() {},
  methods: {
    async fetchHistoryListHandler() {
      this.minDate = new Date(dayjs().tz(DEFAULT_TIMEZONE).subtract(3, 'M').format());
      this.maxDate = new Date(dayjs().tz(DEFAULT_TIMEZONE).format());
      //this.maxDate.setMonth(this.maxDate.getMonth() + 3);

      const query = this.$route.query ? this.$route.query : {};
      const term =
        query.phonebook_name !== '%'
          ? query.phonebook_name
          : query.agent_name !== '%'
          ? query.agent_name
          : query.memo !== '%'
          ? query.memo
          : query.phone_number !== '%'
          ? query.phone_number
          : '';

      const strToday = dayjs().tz(DEFAULT_TIMEZONE).format('YYYY-MM-DD');
      this.searchForm.periods = {
        start: query.start ? query.start : strToday,
        end: query.end ? query.end : strToday,
      };
      this.searchForm.type = query.type ? query.type : 'phonebook_name';
      this.searchForm.term = term ? term.substring(1, term.length - 1) : '';
      this.emptyText = '検索中です';

      this.phonebook_name = query.phonebook_name ? query.phonebook_name : '%';
      this.agent_name = query.agent_name ? query.agent_name : '%';
      this.memo = query.memo ? query.memo : '%';
      this.phone_number = query.phone_number ? query.phone_number : '%';
      this.recordingUrlList = [];
      const formDataTmp = {
        userID: this.userID,
        companyID: this.$route.query.companyID,
        phonebook_name: this.phonebook_name,
        agent_name: this.agent_name,
        memo: this.memo,
        phone_number: this.phone_number,
        start: this.searchForm.periods.start,
        end: this.searchForm.periods.end,
        page: query.page ? query.page : 1,
        _csrf: this.csrfToken,
        recordingUrlList: this.recordingUrlList,
      };
      await this.getQueryList(formDataTmp);
      this.getStatusFilterDataList();
      this.getOverFlowFilterDataList();
      const userListObj = await this.handlerFetchUserData();
      if (userListObj) {
        this.agentFilterDataList = this.convertObjToArray(userListObj);
      }
      if (!this.isInitedFilter) this.initFilter();
    },
    async handleSearchClick() {
      this.recordingUrlList = [];
      if (this.searchForm.type === 'phonebook_name') {
        this.phonebook_name = '%' + this.searchForm.term + '%';
        this.agent_name = '%';
        this.memo = '%';
        this.phone_number = '%';
      } else if (this.searchForm.type === 'agent_name') {
        this.phonebook_name = '%';
        this.agent_name = '%' + this.searchForm.term + '%';
        this.memo = '%';
        this.phone_number = '%';
      } else if (this.searchForm.type === 'memo') {
        this.phonebook_name = '%';
        this.agent_name = '%';
        this.memo = '%' + this.searchForm.term + '%';
        this.phone_number = '%';
      } else if (this.searchForm.type === 'phone_number') {
        this.phonebook_name = '%';
        this.agent_name = '%';
        this.memo = '%';
        this.phone_number = '%' + this.searchForm.term + '%';
      } else if (this.searchForm.type === 'text') {
        this.text = '%' + this.searchForm.term + '%';
        this.agent_name = '%';
        this.memo = '%';
        this.phone_number = '%';
      }
      if (this.searchForm.type === 'text') {
        const textFormData = {
          companyID: this.selectedCompanyID,
          word: this.text,
        };
        const result = await this.postRequest('/voicetotext/search', textFormData);
        if (result.result.length !== 0) {
          for (const data of result.result) {
            this.recordingUrlList.push(data.fileName.split('_')[1]);
          }
        } else {
          this.recordingUrlList = ['######'];
        }
      }
      const formDataTmp = {
        userID: this.userID,
        companyID: this.$route.query.companyID,
        phonebook_name: this.phonebook_name,
        agent_name: this.agent_name,
        memo: this.memo,
        phone_number: this.phone_number,
        start: this.searchForm.periods.start,
        end: this.searchForm.periods.end,
        page: 1,
        recordingUrlList: this.recordingUrlList,
      };
      this.queryList.length = 0;
      this.filterList.length = 0;
      if (!this.hasSpecialCharacterInString(this.searchForm.term)) {
        await this.getQueryList(formDataTmp);
        this.handleFilterConfirm('status', this.checkedStatus, 0);
      } else {
        this.showErrorModal(messageContent.hasSpecialCharacter);
      }
    },
    async handleDownloadClick() {
      let phonebook_name;
      let agent_name;
      let memo;
      let phone_number;
      let text;
      let recordingUrlList = [];
      if (this.searchForm.type === 'phonebook_name') {
        phonebook_name = '%' + this.searchForm.term + '%';
        agent_name = '%';
        memo = '%';
        phone_number = '%';
      } else if (this.searchForm.type === 'agent_name') {
        phonebook_name = '%';
        agent_name = '%' + this.searchForm.term + '%';
        memo = '%';
        phone_number = '%';
      } else if (this.searchForm.type === 'memo') {
        phonebook_name = '%';
        agent_name = '%';
        memo = '%' + this.searchForm.term + '%';
        phone_number = '%';
      } else if (this.searchForm.type === 'phone_number') {
        phonebook_name = '%';
        agent_name = '%';
        memo = '%';
        phone_number = '%' + this.searchForm.term + '%';
      } else if (this.searchForm.type === 'text') {
        text = '%' + this.searchForm.term + '%';
        phonebook_name = '%';
        agent_name = '%';
        memo = '%';
        phone_number = '%';
      }
      if (this.searchForm.type === 'text') {
        const textFormData = {
          companyID: this.selectedCompanyID,
          word: text,
        };
        const result = await this.postRequest('/voicetotext/search', textFormData);
        if (result.result.length !== 0) {
          for (const data of result.result) {
            recordingUrlList.push(data.fileName.split('_')[1]);
          }
        } else {
          recordingUrlList = ['######'];
        }
      }
      const formDataTmp = {
        userID: this.userID,
        companyID: this.$route.query.companyID,
        phonebook_name: phonebook_name,
        agent_name: agent_name,
        memo: memo,
        phone_number: phone_number,
        start: this.searchForm.periods.start,
        end: this.searchForm.periods.end,
        recordingUrlList: recordingUrlList,
      };
      this.queryList.length = 0;
      this.filterList.length = 0;

      this.postRequest('/callLogClient/download', formDataTmp)
        .then(e => {
          const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
          const blob = new Blob([bom, e.data], { type: 'text/plain' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.download = 'callloglist.csv';
          a.href = url;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('発着信履歴ダウンロード'));
        });
    },
    handlePageSelect(e) {
      this.currentPage = e;
      this.getLists(this.filterList);
    },
    handleSubmitSearchForm(e) {
      e.preventDefault();
    },
    search: debounce(function () {
      const payload = cloneDeep(this.searchForm);
    }, 150),
    handleSearchFormSubmit(payload) {
      //console.log(payload);
    },
    getCallStatusIcon(status, voicemessageFlag, overFlowFlag) {
      if (voicemessageFlag === true) {
        return 'phone-voicemail';
        //#4060 あふれ呼用アイコンは使わない
        //} else if (overFlowFlag === true) {
        //return 'phone-over-flow';
      } else {
        if (status === '着信') {
          return 'phone-incoming-call';
        } else if (status === '発信') {
          return 'phone-outgoing-call';
        } else if (status === '内線') {
          return 'phone-extension';
        } else if (status === '不在着信' || status === '非通知着信切断' || status === '海外着信切断') {
          return 'phone-missed-call';
        } else if (status === 'アウトバウンド') {
          return 'outbound';
        }
        return 'phone-outgoing-call';
      }
    },
    getLists(reqList) {
      const end = this.currentPage * this.parPage;
      const start = end - this.parPage;
      this.dataList.length = 0;
      this.dataList = this.dataList.concat(reqList.slice(start, end));
      this.recordingCbx = {};
      for (const row of this.dataList) {
        if (row.recordingUrl) {
          this.recordingCbx[row.CallSid] = false;
        }
      }
    },
    getPageCount(reqList) {
      return Math.ceil(reqList.length / this.parPage);
    },
    // --- FILTERS
    getFilterColumnIndex(prop) {
      let columnIndex = -1;
      this.$refs.dataTable.columns.forEach((column, index) => {
        if (column.prop === prop) {
          columnIndex = index;
        }
      });
      return columnIndex;
    },
    handleFilterCancel(prop) {
      const columnIndex = this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
    },
    handleFilterConfirm(prop, data, cnt) {
      this.filter[prop] = data;
      let baseList = [];
      let tmpList = [];
      if (cnt === 0) {
        baseList = this.queryList.concat();
      } else if (cnt === 1) {
        baseList = this.filterList.concat();
      }
      if (data.length === 0) {
        tmpList = tmpList.concat(baseList);
      } else {
        for (let i = 0; i < data.length; i++) {
          const result = baseList.filter(function (row) {
            return String(row[prop]) === String(data[i]);
          });
          tmpList = tmpList.concat(result);
        }
      }
      this.filterList.length = 0;
      this.filterList = tmpList.concat();

      if (cnt === 0) {
        //ステータスのフィルタ処理
        if (prop === 'status') {
          this.checkedStatus = data.concat();
          //ステータスフィルタの後、他のフィルタも処理する
          this.handleFilterConfirm('agent_name', this.checkedAgent, 1);
          this.handleFilterConfirm('phone_number', this.checkedPhoneNumber, 1);
          this.handleFilterConfirm('overFlowFlag', this.checkedOverFlow, 1);
          //応対者のフィルタ処理
        } else if (prop === 'agent_name') {
          this.checkedAgent.length = 0;
          this.checkedAgent = data.concat();
          //応対者フィルタの後、他のフィルタも処理する
          this.handleFilterConfirm('status', this.checkedStatus, 1);
          this.handleFilterConfirm('phone_number', this.checkedPhoneNumber, 1);
          this.handleFilterConfirm('overFlowFlag', this.checkedOverFlow, 1);
          //自番号のフィルタ処理
        } else if (prop === 'phone_number') {
          this.checkedPhoneNumber.length = 0;
          this.checkedPhoneNumber = data.concat();
          //自番号フィルタの後、他のフィルタも処理する
          this.handleFilterConfirm('status', this.checkedStatus, 1);
          this.handleFilterConfirm('agent_name', this.checkedAgent, 1);
          this.handleFilterConfirm('overFlowFlag', this.checkedOverFlow, 1);
        } else if (prop === 'overFlowFlag') {
          this.checkedOverFlow.length = 0;
          this.checkedOverFlow = data.concat();
          //応対者フィルタの後、他のフィルタも処理する
          this.handleFilterConfirm('status', this.checkedStatus, 1);
          this.handleFilterConfirm('agent_name', this.checkedAgent, 1);
          this.handleFilterConfirm('phone_number', this.checkedPhoneNumber, 1);
        }
      }

      this.pageCount = this.getPageCount(this.filterList);
      this.handlePageSelect(1);
      this.getLists(this.filterList);

      if (this.dataList.length === 0) {
        this.emptyText = messageContent.alertMessageEmptyText();
      }

      const columnIndex = this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
      this.handleSort(this.filterColumn, this.filterSort);
      //this.handleFilterUpdate(prop, cloneDeep(data));
    },
    handleSort(prop, dir) {
      this.filter[prop] = dir;
      //sort設定を保存
      this.filterColumn = prop;
      this.filterSort = dir;
      //昇順
      if (dir === 'asc') {
        this.filterList.sort(function (a, b) {
          if (a[prop] < b[prop]) return -1;
          if (a[prop] > b[prop]) return 1;
          return 0;
        });
        this.getLists(this.filterList);
      }
      //降順
      if (dir === 'desc') {
        this.filterList.sort(function (a, b) {
          if (a[prop] > b[prop]) return -1;
          if (a[prop] < b[prop]) return 1;
          return 0;
        });
        this.getLists(this.filterList);
      }
      //const columnIndex = this.getFilterColumnIndex(prop);
      const columnIndex = prop === 'seconds' ? this.getFilterColumnIndex('dispTime') : this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
    },
    initFilter() {
      if (this.isInitedFilter) return;
      if (this.filter['status']) this.handleFilterConfirm('status', this.filter['status'], 1);
      if (this.filter['agent_name']) this.handleFilterConfirm('agent_name', this.filter['agent_name'], 1);
      if (this.filter['start_dt']) this.handleSort('start_dt', this.filter['start_dt']);
      if (this.filter['seconds']) this.handleSort('seconds', this.filter['seconds']);
      if (this.$route.query.page) this.handlePageSelect(parseInt(this.$route.query.page));
      this.isInitedFilter = true;
    },
    async handlerFetchUserData() {
      return await this.postRequest('/callLogClient/getuserlist', { companyID: this.$route.query.companyID })
        .then(e => {
          return e.data;
        })
        .catch(() => {
          //this.showErrorModal('検索中にエラーが発生しました。時間を空けて再度実行してください。');
          return null;
        });
    },
    convertObjToArray(data) {
      const tempArray = [];
      const retArray = [];
      Object.keys(data).map(function (key) {
        const obj = Object.assign({}, data[key]);
        obj.userID = key;
        tempArray.push(obj);
      });
      for (let i = 0; i < tempArray.length; i++) {
        retArray.push({ label: tempArray[i].username, value: tempArray[i].username });
      }
      return retArray;
    },
    getStatusFilterDataList() {
      this.statusFilterDataList = [
        {
          label: '発信',
          value: '発信',
        },
        {
          label: 'アウトバウンド',
          value: 'アウトバウンド',
        },
        {
          label: '着信',
          value: '着信',
        },
        {
          label: '不在着信',
          value: '不在着信',
        },
        {
          label: '内線',
          value: '内線',
        },
        {
          label: '留守電',
          value: '留守電',
        },
      ];
    },
    getOverFlowFilterDataList() {
      this.overFlowFilterDataList = [
        {
          label: '◯',
          value: true,
        },
        {
          label: '　',
          value: false,
        },
      ];
    },
    getQueryList: async function (formDataTmp) {
      await this.postRequest('/callLogClient/getcalllog', formDataTmp)
        .then(e => {
          if (e.status) {
            // 古いデータは内線の時はphone_numberの値も入ったので空にセットする
            for (const row of e.data) {
              if (row.status === '内線') row.phone_number = '';
            }
            this.queryList.length = 0;
            this.filterList.length = 0;
            this.queryList = this.queryList.concat(e.data);
            this.filterList = this.filterList.concat(e.data);
            this.pageCount = this.getPageCount(this.queryList);
            this.handlePageSelect(parseInt(formDataTmp.page));
            this.getLists(e.data);
            this.getPhoneNumberList(e.data);
            //this.showInfoModal('設定を変更しました。');
            if (e.data.length === 0) {
              this.emptyText = messageContent.alertMessageEmptyText();
            }
          } else {
            //console.log(e);
            this.emptyText = messageContent.requireTry('データ取得');
          }
        })
        .catch(er => {
          //console.log(er);
          this.emptyText = messageContent.requireTry('データ取得');
        });
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlistCCCOnly', { withPoint: true }) // #2423
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('登録ユーザー取得'));
        });
    },
    /*
    getNowDateWithString() {
      const dt = new Date();
      const y = dt.getFullYear();
      const m = ('00' + (dt.getMonth() + 1)).slice(-2);
      const d = ('00' + dt.getDate()).slice(-2);
      const result = y + '-' + m + '-' + d;
      return result;
    },
    */
    handleRowClick(row) {
      if (this.companyID === POINT) {
        const routeData1 = this.$router.push({
          name: 'HistoryDetail',
          query: {
            companyID: this.selectedCompanyID,
            CallSid: row.CallSid,
            search_phonebook_name: this.phonebook_name,
            search_agent_name: this.agent_name,
            search_memo: this.memo,
            start: this.searchForm.periods.start,
            end: this.searchForm.periods.end,
            type: this.searchForm.type,
            page: this.currentPage,
            search_phone_number: this.phone_number,
            status: row.status,
            agent_name: row.agent_name,
          },
          params: { filter: JSON.stringify(this.filter) },
        });
      } else {
        const routeData2 = this.$router.push({
          name: 'HistoryDetail',
          query: {
            CallSid: row.CallSid,
            search_phonebook_name: this.phonebook_name,
            search_agent_name: this.agent_name,
            search_memo: this.memo,
            start: this.searchForm.periods.start,
            end: this.searchForm.periods.end,
            type: this.searchForm.type,
            page: this.currentPage,
            search_phone_number: this.phone_number,
            status: row.status,
            agent_name: row.agent_name,
          },
          params: { filter: JSON.stringify(this.filter) },
        });
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleCloseModal() {
      this.modalFlg = '';
      this.selectedRecordingUrl = '';
      this.selectedCallSid = '';
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showDeleteRecordingModal(message) {
      this.resultModalTitle = messageContent.infoModalTitle;
      this.deleteRecordingModalVisible = true;
      this.deleteRecordingModalContent = message;
    },
    handleCancelDeleteRecordingModal() {
      this.resultModalTitle = '';
      this.deleteRecordingModalVisible = false;
      this.deleteRecordingModalContent = '';
    },
    handleOKDeleteRecordingModal() {
      this.resultModalTitle = '';
      this.deleteRecordingModalVisible = false;
      this.deleteRecordingModalContent = '';
      this.postRequest('/callLogClient/deleteRecording', {
        CallSids: this.recordingCbx,
        companyID: this.selectedCompanyID,
      })
        .then(res => {
          if (res.status === 'success') {
            this.handleHideDeletedRecording(this.dataList);
            this.handleHideDeletedRecording(this.filterList);
            this.handleHideDeletedRecording(this.queryList);
            this.recordingCbx = {};
            this.showInfoModal(messageContent.notifySuccess('通話録音の削除'));
          } else {
            this.showErrorModal(messageContent.requireTry('通話録音の削除'));
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('通話録音の削除'));
        });
    },
    handleHideDeletedRecording(dataList) {
      const callSids = []; // the callSid of deleted recordings
      for (const callSid in this.recordingCbx) {
        if (this.recordingCbx[callSid]) callSids.push(callSid);
      }
      for (const row of dataList) {
        if (callSids.includes(row.CallSid)) {
          row.recordingUrl = null;
        }
      }
    },
    deleteRecording() {
      if (!this.disableDeleteButton) {
        // テキスト化の使用/未使用で文言を変更する
        if (this.voiceToTextOn) {
          this.showDeleteRecordingModal(messageContent.confirmDeleteRecording);
        } else {
          this.showDeleteRecordingModal(messageContent.confirmDeleteRecordingOther);
        }
      } else {
        this.showErrorModal(messageContent.requireChoice('最低一つの通話録音'));
      }
    },
    doCheckAll() {
      for (const CallSid in this.recordingCbx) {
        this.recordingCbx[CallSid] = !this.checkAllCbx;
      }
    },
    async handlePlayRecordingClick(row) {
      try {
        this.playRecordingModalVisible = true;
        this.selectedRow = row;
        // 通話録音データは既に取得した場合、再度取得するのは必要ない
        if (this.audioURLs[row.CallSid]) return;
        this.loading = true;
        // 通話録音データ取得
        const audioData = await this.fetchAudioData(this.getRecordingDownloadURL(row.urlPartial));
        this.audioDataList[row.CallSid] = audioData;
        // 取得した通録データをAudio Playerに設定する
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        const url = window.URL.createObjectURL(audioData);
        this.audioURLs[row.CallSid] = url;
        const audioElem = document.querySelector('audio');
        if (audioElem) {
          audioElem.src = url;
          audioElem.onload = evt => {
            URL.revokeObjectURL(url);
          };
        }
        this.loading = false;
      } catch (error) {
        console.debug('handlePlayRecordingClick', error);
        this.loading = false;
        this.playRecordingModalVisible = false;
        this.showErrorModal(messageContent.recordingNotFound);
      }
    },
    getRecordingDownloadURL(urlPartial) {
      return `${location.origin}/Recordings/${urlPartial}`;
    },
    async getChunk(url, index, start) {
      const tCompanyID = this.companyID === POINT ? this.$route.query.companyID : this.companyID;
      const res = await fetch(`${url}?index=${index}&start=${start}&companyID=${tCompanyID}`, {
        method: 'GET',
      });
      if (res.status !== 200) throw messageContent.recordingNotFound;
      const isLastChunk = res.headers.get('Last-Chunk');
      const loadedSize = res.headers.get('Loaded-Size');
      const blob = await res.blob();
      return { blob, isLastChunk, loadedSize };
    },
    async fetchAudioData(url) {
      const segments = [];
      let loadedSize = 0;
      let [isLastChunk, i] = [null, 0];
      while (isLastChunk !== 'true') {
        const chunk = await this.getChunk(url, i, parseInt(loadedSize));
        const buffer = await chunk.blob.arrayBuffer();
        isLastChunk = chunk.isLastChunk;
        loadedSize = chunk.loadedSize;
        segments.push(buffer);
        i++;
      }
      const length = segments.reduce((size, segment) => {
        return size + segment.byteLength;
      }, 0);
      const mediaData = new Uint8Array(length);
      let pos = 0;
      for (let i = 0; i < segments.length; ++i) {
        mediaData.set(new Uint8Array(segments[i]), pos);
        pos += segments[i].byteLength;
      }
      return new Blob([mediaData.buffer], { type: 'audio/wav' });
    },
    handleDownloadRecordingClick() {
      const link = document.createElement('a');
      link.href = this.audioURLs[this.selectedRow.CallSid];
      link.download = `${this.selectedRow.start_dt.replace(/[^0-9]/g, '')}.wav`;
      link.click();
    },
    handleClickBulkDownloadRecording() {
      if (this.skipRecordingBulkDownloadModal) {
        // モーダルを表示せずダウンロードを開始する
        this.handleBulkDownloadRecording();
      } else {
        // モーダルを表示する
        this.handleOpenBulkDownloadModal();
      }
    },
    async handleBulkDownloadRecording() {
      try {
        this.handleCloseBulkDownloadModal();
        if (!this.skipRecordingBulkDownloadModal && this.skipRecordingBulkDownloadModalCbx) {
          this.skipRecordingBulkDownloadModal = true;
          this.postRequest('/callLogClient/setSkipRecordingBulkDownloadModal');
        }
        this.isFullPageLoading = true; // show loading
        const downloadTargetList = {}; // 選択された項目一覧
        for (const callSid in this.recordingCbx) {
          if (!this.recordingCbx[callSid]) continue;
          for (const item of this.dataList) {
            if (item.CallSid === callSid && item.recordingUrl) {
              downloadTargetList[callSid] = { urlPartial: item.urlPartial, start_dt: item.start_dt };
            }
          }
        }
        // download list is empty
        if (!Object.keys(downloadTargetList).length) {
          this.isFullPageLoading = false;
          return;
        }
        // download list have only one item
        if (Object.keys(downloadTargetList).length === 1) {
          const callSid = Object.keys(downloadTargetList)[0];
          if (!this.audioURLs[callSid]) {
            // ダウンロード対象ファイルはまだロードしない場合、データを取得してからダウンロード
            const urlPartial = downloadTargetList[callSid].urlPartial;
            const audioData = await this.fetchAudioData(this.getRecordingDownloadURL(urlPartial));
            this.audioDataList[callSid] = audioData;
            const url = window.URL.createObjectURL(audioData);
            this.audioURLs[callSid] = url;
          }
          const link = document.createElement('a');
          link.href = this.audioURLs[callSid];
          link.download = `${downloadTargetList[callSid].start_dt.replace(/[^0-9]/g, '')}.wav`;
          link.click();
        } else {
          /* download multiple recordings as zip file */
          const zip = new JSZip();
          for (const callSid in downloadTargetList) {
            let audioData = this.audioDataList[callSid];
            if (!audioData) {
              const urlPartial = downloadTargetList[callSid].urlPartial;
              audioData = await this.fetchAudioData(this.getRecordingDownloadURL(urlPartial));
              this.audioDataList[callSid] = audioData;
              const url = window.URL.createObjectURL(audioData);
              this.audioURLs[callSid] = url;
            }
            zip.file(`${downloadTargetList[callSid].start_dt.replace(/[^0-9]/g, '')}.wav`, audioData);
          }
          const filename = `${this.getFormatedDatetime(new Date(), 'YYYYMMDDhhmmss')}.zip`;
          zip.generateAsync({ type: 'blob' }).then(function (blob) {
            saveAs(blob, filename);
          });
        }
        this.isFullPageLoading = false;
      } catch (error) {
        this.isFullPageLoading = false;
        console.debug('handleClickBulkDownloadRecording', error);
        this.showErrorModal(messageContent.recordingNotFound);
      }
    },
    getFormatedDatetime(_dt, _fmt) {
      return [
        ['YYYY', _dt.getFullYear()],
        ['MM', _dt.getMonth() + 1],
        ['DD', _dt.getDate()],
        ['hh', _dt.getHours()],
        ['mm', _dt.getMinutes()],
        ['ss', _dt.getSeconds()],
      ].reduce((s, a) => s.replace(a[0], `${a[1]}`.padStart(a[0].length, '0')), _fmt);
    },
    doVoiceToText(recordingUrl, callSid) {
      for (const row of this.dataList) {
        if (recordingUrl === row.recordingUrl) {
          row.voiceToTextStatus = 'processing';
        }
      }
      const formData = {
        recordingUrl: recordingUrl,
        companyID: this.selectedCompanyID,
        callSid: callSid,
      };
      this.postRequest('/voicetotext/createWavFile', formData);
      this.handleCloseModal();
    },
    confirmDoVoiceToText(recordingUrl, callSid) {
      this.handleCloseModal();
      if (this.voiceToTextOn) {
        this.selectedRecordingUrl = recordingUrl;
        this.selectedCallSid = callSid;
        this.modalFlg = 'confirmDoVoiceToText';
        this.showInfoModal(messageContent.confirmDoVoiceToText);
      }
    },
    showAbsentError(item) {
      this.showErrorModal(messageContent.notifyAbsentError(item));
    },
    getPhoneNumberList(rows) {
      this.phoneNumberFilterDataList = [];
      const loadedNumbers = [];
      for (const row of rows) {
        if (row.phone_number && !loadedNumbers.includes(row.phone_number)) {
          loadedNumbers.push(row.phone_number);
          this.phoneNumberFilterDataList.push({ label: row.phone_number, value: row.phone_number });
        }
      }
    },
    doTextHighLight(index) {
      this.isTextHover[index] = true;
    },
    doNotTextHighLight(index) {
      this.isTextHover[index] = false;
    },
    doRecordingHighLight(index) {
      this.isRecordingHover[index] = true;
    },
    doNotRecordingHighLight(index) {
      this.isRecordingHover[index] = false;
    },
    doTrashHighLight(index) {
      this.isTrashHover[index] = true;
    },
    handleOpenBulkDownloadModal() {
      this.resultModalTitle = messageContent.infoModalTitle;
      this.bulkDownloadModalVisible = true;
    },
    handleCloseBulkDownloadModal() {
      this.bulkDownloadModalVisible = false;
    },
  },
};
</script>
